// this function is only meant to be used in the browser;
// it returns an empty string when on the server
export function getPreferredLocaleClientSide() {
    // note: first locale is the user's first preference
    const isBrowser = typeof document !== 'undefined'
    return isBrowser ? navigator.languages[0] : ''
}
